const equipment = {
  title: 'INACTIVATE EQUIPMENT'
}

export default equipment;
